<template>
  <div class="HeadRotation">
<!-- 列表轮播图 -->
    <div class="swiper-container qwe">
      <div class="swiper-wrapper">
		<div class="swiper-slide">
			<img src="../assets/images/product/product.jpg" alt="" class="swiperImg">
			<p class="content">精致型车牌识别一体机</p>
		</div>
		<div class="swiper-slide">
			<img src="../assets/images/product/product2.jpg" alt="" class="swiperImg">
			<p class="content">豪华型车牌识别一体机</p>
		</div>
		<div class="swiper-slide">
			<img src="../assets/images/product/product3.jpg" alt="" class="swiperImg">
			<p class="content">尊贵型车牌识别一体机</p>
		</div>
		<div class="swiper-slide">
			<img src="../assets/images/product/product8.jpg" alt="" class="swiperImg">
			<p class="content">道闸</p>
		</div>
		<div class="swiper-slide">
			<img src="../assets/images/product/product5.png" alt="" class="swiperImg">
			<p class="content">低位雷达视频</p>
		</div>
		<div class="swiper-slide">
			<img src="../assets/images/product/product4.jpg" alt="" class="swiperImg">
			<p class="content">枪球联动一体机</p>
		</div>
		<div class="swiper-slide">
			<img src="../assets/images/product/product5.jpg" alt="" class="swiperImg">
			<p class="content">车牌识别手持终端</p>
		</div>
		<div class="swiper-slide">
			<img src="../assets/images/product/product7.jpg" alt="" class="swiperImg">
			<p class="content">车位诱导屏</p>
		</div>
      </div>
    </div>
  </div>
</template>

<script>   //局部引入swiper插件
import '@/assets/css/swiper.css'    //在全局没引入，这里记得要！
import image from '@/assets/images/back.png'
import image1 from '@/assets/images/logo.png'
import Swiper from 'swiper'
export default {
    name: "HeadRotation",
    data () {
        return {
            image: image,
            image1: image1
        }
    },
    mounted() {
        new Swiper ('.swiper-container', {
			slidesPerView: 4.06,
			paginationClickable: true,
			spaceBetween: 30,
            loop: true, // 循环模式选项
            autoplay: true,//自动循环
			autoplay: {
			  delay: 1000,//时间 毫秒
			  disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
			}
        })
// 
    },

};
</script>
<style>
	.swiper-container {
	    width: 100%;
		height:420px;
		margin-top: 50px;
	}
	.swiper-containe:first-child{
		margin-left: -10px;
	}
	.swiper-slide {
		height:415px;
		background: #fff;
		border: 1px solid #efefef;
		border-radius: 5px;
		position: relative;
		box-shadow: 6px 6px 12px rgba(243,243,243,0.5);
	}
	.content{
		position: absolute;
		bottom: 0;
		left: 0;
		height: 40px;
		line-height: 40px;
		width: 100%;
		background: rgba(0,0,0,0.5);
		color: #fff;
		text-align: center;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
	}
	.swiperImg{
		width: 100%;
 		height: 100%;
		object-fit: cover;
	}
</style>
<style lang="scss" scoped>
.banner {
	width: 100%;
	.swiper-container {
        width: 100%;
        height: 300px;
        margin: 20px auto;
    }
	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: #fff;
		/* Center slide text vertically */
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
		height:385px;
		background: #fff;
		border: 1px solid #efefef;
		border-radius: 5px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/swiperHome.vue